import { Routes, Route, useLocation } from 'react-router-dom';

import { Navbar } from './components';
import { HomePage, ContactPage, CaseStudyPage } from './pages';

const App = () => {
  const location = useLocation();

  return (
    <main className="bg-white font-montserrat dark:bg-black2 transition min-h-screen">
      <Navbar bg={location.pathname === '/contact' || location.pathname.includes('/case-study')} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/case-study/:id" element={<CaseStudyPage />} />
      </Routes>
    </main>
  );
};

export default App;
